import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

/**
 * Finds a career path suggestion by career path ID from the survey results
 * @param careerPathId - The ID of the career path to find
 * @param careerPathSuggestions - Array of career path suggestions from survey results
 * @returns The career path suggestion if found, null otherwise
 */
export const findCareerPathSuggestionById = (
  careerPathId: number,
  careerPathSuggestions: CareerPathWithScore[],
): CareerPathWithScore | null => {
  return (
    careerPathSuggestions.find((suggestion) => suggestion.careerPath.id === careerPathId) || null
  );
};

/**
 * Filters career path suggestions by score section
 * @param careerPathSuggestions - Array of career path suggestions
 * @param scoreSection - The score section to filter by ('TOP', 'MIDDLE', 'LOW')
 * @returns Array of career path suggestions matching the score section
 */
export const filterCareerPathSuggestionsByScoreSection = (
  careerPathSuggestions: CareerPathWithScore[],
  scoreSection: CareerPathWithScore['scoreSection'],
): CareerPathWithScore[] => {
  return careerPathSuggestions.filter((suggestion) => suggestion.scoreSection === scoreSection);
};

/**
 * Gets the top N career path suggestions by score
 * @param careerPathSuggestions - Array of career path suggestions
 * @param count - Number of top suggestions to return
 * @returns Array of top N career path suggestions sorted by score
 */
export const getTopCareerPathSuggestions = (
  careerPathSuggestions: CareerPathWithScore[],
  count: number,
): CareerPathWithScore[] => {
  return [...careerPathSuggestions].sort((a, b) => b.sum - a.sum).slice(0, count);
};
